import type { FlowStep } from '@/data'
import type { BrandingEditorConfig } from '../../BrandingEditor'

export {
  type FormFieldName,
  requiredFormFieldIds,
  availableFormInputs,
} from '../shared/config'

export const brandingConfig: BrandingEditorConfig = {
  title: 'Cobranding',
  customColorFields: [
    {
      key: 'show_reviews',
      label: 'Show Reviews',
      default: false,
      type: 'toggle',
    },
  ],
}

export function isDebtStep(step: FlowStep): boolean {
  return step.inputs.some((i) => i.type === 'radio' && i.value != null)
}

export function isFormStep(step: FlowStep): boolean {
  return !step.inputs.some((i) => i.type === 'radio')
}

export function validateSteps(steps: FlowStep[]): string[] {
  const errors: string[] = []
  const hasDebt = steps.some(isDebtStep)

  if (!hasDebt) {
    const allFormInputIds = new Set<string>()
    steps
      .filter(isFormStep)
      .forEach((s) => s.inputs.forEach((i) => allFormInputIds.add(i.id)))

    const missing: string[] = []
    if (!allFormInputIds.has('birthdate')) missing.push('Date of Birth')
    if (!allFormInputIds.has('address')) missing.push('Address')

    if (missing.length > 0) {
      errors.push(`Missing Debt Amount step or ${missing.join(' and ')}`)
    }
  }

  return errors
}

export const defaultSteps: FlowStep[] = [
  {
    ordinal: 1,
    headline: "What's your estimated debt balance?",
    sub_headline: '',
    cta_button: '',
    inputs: [
      {
        id: 'under10k',
        label: 'Under $10,000',
        type: 'radio',
        placeholder: null,
        required: false,
        value: '9999',
        action: 'downsell',
      },
      {
        id: '10to25k',
        label: '$10,000 - $25,000',
        type: 'radio',
        placeholder: null,
        required: false,
        value: '15000',
        action: 'progress',
      },
      {
        id: 'over25k',
        label: 'More than $25,000',
        type: 'radio',
        placeholder: null,
        required: false,
        value: '25000',
        action: 'progress',
      },
    ],
  },
  {
    ordinal: 2,
    headline: 'This is the Last Step, Promise!',
    sub_headline: '',
    cta_button: 'See If You Qualify*',
    inputs: [
      {
        id: 'name',
        label: 'Name',
        type: 'text',
        placeholder: null,
        required: true,
      },
      {
        id: 'email',
        label: 'Email',
        type: 'email',
        placeholder: null,
        required: true,
      },
      {
        id: 'phone',
        label: 'Phone',
        type: 'phone',
        placeholder: null,
        required: true,
      },
      {
        id: 'state',
        label: 'State',
        type: 'select',
        placeholder: null,
        required: true,
      },
    ],
  },
]
